import { useNavigate } from 'react-router-dom'

import { ResourceHeader } from '@factorialco/f0-react/dist/experimental'
import { Delete, Pencil } from '@factorialco/f0-react/icons/app'
import { FinanceDimensionValueMembersQuery } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

interface Props {
  dimension: FinanceDimensionValueMembersQuery['finance']['customDimensionValue']
}

const Header = ({ dimension }: Props) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const legalEntityValue =
    dimension?.legalEntity?.legalName ?? i18n.t('finance.dimension_detail.table.all_legal_entities')

  if (!dimension) {
    return null
  }

  return (
    <ResourceHeader
      title={dimension.name}
      description={dimension.description ?? undefined}
      secondaryActions={[
        {
          icon: Delete,
          variant: 'critical',
          label: i18n.t('common.delete'),
          onClick: () => {
            navigate(
              navigation.settings.finance.dimensions.dimension.values.delete.fullPath({
                id: dimension.customDimension.id,
                value_id: dimension.id,
              })
            )
          },
        },
        {
          icon: Pencil,
          label: i18n.t('common.edit'),
          onClick: () => {
            navigate(
              navigation.settings.finance.dimensions.dimension.values.edit.fullPath({
                id: dimension.customDimension.id,
                value_id: dimension.id,
              })
            )
          },
        },
      ]}
      metadata={[
        dimension.code
          ? {
              label: i18n.t('finance.dimension_detail.table.code'),
              value: {
                type: 'text',
                content: dimension.code,
              },
            }
          : undefined,
        {
          label: i18n.t('finance.dimension_detail.table.legal_entity'),
          value: {
            type: 'text',
            content: legalEntityValue,
          },
        },
      ]}
    />
  )
}

export default Header
